// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__fOYD5","fileBtn":"File_fileBtn__Sv68D","closeBtn":"File_closeBtn__4Ot4s","fileSelected":"File_fileSelected__1Ayxm","disabled":"File_disabled__89n1C"};